<template>
  <ValidationObserver>
    <form>
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Application - <small>Detail</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Code
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <md-field>
                <label>Code</label>
                <md-input :value="code" type="text" disabled> </md-input>
              </md-field>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              University
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="university"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>University</label>
                  <md-select disabled v-model="university" name="university">
                    <md-option value="">Select University</md-option>
                    <md-option :value="university">{{
                      university_name
                    }}</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <label class="md-layout-item md-size-25 md-form-label">
              Program
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="program"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Program</label>
                  <md-select disabled v-model="program" name="program">
                    <md-option value="">Select Program</md-option>
                    <md-option
                      v-for="c in programs"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <label class="md-layout-item md-size-25 md-form-label">
              Degree
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Degree</label>
                  <md-select v-model="type" name="type" disabled>
                    <md-option value="">Select University</md-option>
                    <md-option value="1">Associate degree</md-option>
                    <md-option value="2">Bachelor degree</md-option>
                    <md-option value="3">Master Non-Thesis</md-option>
                    <md-option value="4">Master With Thesis</md-option>
                    <md-option value="5">Phd degree</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Language
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <md-field>
                <label>Language</label>
                <md-input :value="education_language" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Education Type
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <md-field>
                <label>Education Type</label>
                <md-input :value="education_type" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Season
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="season"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Season</label>
                  <md-select disabled v-model="season" name="season">
                    <md-option value="">Select Season</md-option>
                    <md-option
                      v-for="c in seasons"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              From
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <md-field>
                <label>From</label>
                <md-input :value="from_application" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Status
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <ValidationProvider
                name="application_status"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Status</label>
                  <md-select
                    disabled
                    v-model="application_status"
                    name="application_status"
                  >
                    <md-option value="">Select Status</md-option>
                    <md-option
                      v-for="c in all_application_status"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Is approved?
            </label>
            <div class="md-layout md-layout-item md-size-75">
              <md-field class="md-layout-item md-size-85">
                <md-input
                  :value="booleanToString(is_approved)"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
              <md-button
                class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
                @click="handleApproveApplication"
                target="_blank"
                v-if="!is_approved && $store.role === 1"
              >
                <md-icon>done</md-icon>
                <md-tooltip md-direction="bottom">Approve</md-tooltip>
              </md-button>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Uni. Apply Code
            </label>
            <div class="md-layout md-layout-item md-size-75">
              <md-field class="md-layout-item md-size-85">
                <label>University Apply Code</label>
                <md-input
                  v-model="uni_code"
                  type="text"
                  :disabled="is_apply_to_university || $store.role !== 1"
                ></md-input>
              </md-field>
              <md-button
                class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
                @click="handleSentApplication"
                target="_blank"
                v-if="!is_apply_to_university && $store.role === 1"
              >
                <md-icon>done</md-icon>
                <md-tooltip md-direction="bottom">Sent</md-tooltip>
              </md-button>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="student_number"
            >
              Student Number
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="student_number"
            >
              <md-field>
                <label>Student Number</label>
                <md-input :value="student_number" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label class="md-layout-item md-size-25 md-form-label">
              Price
            </label>
            <div class="md-layout-item md-size-75 md-small-size-100">
              <md-field>
                <label>Price</label>
                <md-input :value="price + ' ' + currency" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="$store.role === 1 && commission !== 0"
            >
              Commission
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="$store.role === 1 && commission !== 0"
            >
              <md-field>
                <label>Commission</label>
                <md-input :value="'% ' + commission" type="text" disabled>
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="$store.role === 1"
            >
              KDV
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="$store.role === 1"
            >
              <md-field>
                <label>KDV</label>
                <md-input :value="'% ' + kdv" type="text" disabled> </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="$store.role === 1"
            >
              GV
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="$store.role === 1"
            >
              <md-field>
                <label>GV</label>
                <md-input :value="'% ' + gv" type="text" disabled> </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="$store.role === 1 && commission_price !== 0"
            >
              Commission Price
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="$store.role === 1 && commission_price !== 0"
            >
              <md-field>
                <label>Commission Price</label>
                <md-input
                  :value="commission_price + ' USD'"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="fix_commission_price !== '0.00'"
            >
              Fix Commission Price
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="fix_commission_price !== '0.00'"
            >
              <md-field>
                <label>Fix Commission Price</label>
                <md-input
                  :value="fix_commission_price + ' USD'"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="partner_parent_commission !== 0"
            >
              Agency Parent Commission
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="partner_parent_commission !== 0"
            >
              <md-field>
                <label>Agency Parent Commission</label>
                <md-input
                  :value="'% ' + partner_parent_commission"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="partner_parent_price !== 0"
            >
              Agency Parent Commission Price
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="partner_parent_price !== 0"
            >
              <md-field>
                <label>Agency Commission Price</label>
                <md-input
                  :value="partner_parent_price + ' ' + currency"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="partner_commission !== 0"
            >
              Agency Commission
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="partner_commission !== 0"
            >
              <md-field>
                <label>Agency Commission</label>
                <md-input
                  :value="'% ' + partner_commission"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-size-25 md-form-label"
              v-if="partner_price !== 0"
            >
              Agency Commission Price
            </label>
            <div
              class="md-layout-item md-size-75 md-small-size-100"
              v-if="partner_price !== 0"
            >
              <md-field>
                <label>Agency Commission Price</label>
                <md-input
                  :value="partner_price + ' ' + currency"
                  type="text"
                  disabled
                >
                </md-input>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";
import Swal from "sweetalert2";

extend("required", required);
extend("numeric", numeric);

export default {
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      applicationID: null,

      universities: [],
      programs: [],
      seasons: [],
      user: null,
      program: null,
      type: null,
      education_language: null,
      education_type: null,
      season: null,
      university: null,
      university_name: null,
      application_status: null,
      from_application: null,
      price: null,
      commission: null,
      currency: null,
      kdv: null,
      gv: null,
      commission_price: null,
      fix_commission_price: null,
      partner_commission: null,
      partner_price: null,
      partner_parent_commission: null,
      partner_parent_price: null,
      scholarship_status: null,
      code: null,
      uni_code: null,
      student_number: null,
      is_apply_to_university: null,
      is_approved: null,

      error_message: null,

      all_application_status: [
        { id: 10, name: "New application" },
        { id: 20, name: "On process" },
        { id: 150, name: "Missing documents" },
        { id: 160, name: "Declined/Rejected" },
        { id: 50, name: "Offer sent" },
        { id: 60, name: "Waiting Final acceptance" },
        { id: 70, name: "Acceptance letter sent" },
        { id: 80, name: "Visa applied" },
        { id: 90, name: "Visa received" },
        { id: 100, name: "Visa rejected" },
        { id: 110, name: "Enrolled (Waiting student certificate)" },
        { id: 120, name: "Enrolled" },
        { id: 130, name: "Refund requested" },
        { id: 140, name: "Refunded" },
        { id: 170, name: "Frozen" },
        { id: 180, name: "Cancelled" },
        { id: 190, name: "Dropped" }
      ]
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    booleanToString(bool) {
      var value = "No";
      if (bool) {
        value = "Yes";
      }
      return value;
    },
    handleApproveApplication(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, approve it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.approveApplication(item);
        }
      });
    },
    approveApplication() {
      this.$store
        .approveApplication(this.applicationID)
        .then(response => {
          this.is_approved = true;
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.detail,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    handleSentApplication(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, sent it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.sentApplication(item);
        }
      });
    },
    sentApplication() {
      var data = {};
      if (this.uni_code) {
        data = { uni_code: this.uni_code };
      }
      this.$store
        .sendApplication(this.applicationID, data)
        .then(response => {
          this.is_apply_to_university = true;
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.detail,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.applicationID = this.$route.params.application_id;
  }
};
</script>
